/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/discussions';

const RequiredFieldLabel = () => (
  <Typography2
    component="p"
    variant="bodyPrimary"
    css={css`
      margin-bottom: var(--cds-spacing-100);
    `}
  >
    <FormattedMessage
      message={_t('Fields marked with an asterisk({symbol}) are required.')}
      symbol={
        <span
          css={css`
            color: var(--cds-color-red-700);
          `}
        >
          *
        </span>
      }
    />
  </Typography2>
);

export default RequiredFieldLabel;
